// extracted by mini-css-extract-plugin
export default {"main":"settingsPage_main__IrL2a","input":"settingsPage_input__GTfIe","menu":"settingsPage_menu__v-q84"};